import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrArrowUpIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M1.21425 10.7784C1.49989 11.0739 1.96298 11.0739 2.24858 10.7783L7.99964 4.827L13.7514 10.7783C14.0371 11.0739 14.5002 11.0739 14.7858 10.7783C15.0714 10.4828 15.0714 10.0037 14.7858 9.70813L8.51678 3.22165C8.37961 3.07972 8.19357 2.99999 7.99959 3C7.8056 3.00001 7.61957 3.07975 7.48241 3.22168L1.21419 9.70817C0.92858 10.0037 0.928609 10.4829 1.21425 10.7784Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrArrowUpIconComponent;
